import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79f14c03&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f14c03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f14c03')) {
      api.createRecord('79f14c03', component.options)
    } else {
      api.reload('79f14c03', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79f14c03&scoped=true", function () {
      api.rerender('79f14c03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classification/index.vue"
export default component.exports